import { i18n, translate as $t } from '../language/i18n_mounting'
//模拟数据

//      /**
//      * Sort 排序类型
//      * **/
//         { 'label': 'endding', 'val': 'EffectiveTimeStamp', 'sortType': 'ASC', 'active':'primary' },
//         { 'label': 'Newly', 'val': 'LastOnTimeStamp', 'sortType': 'DESC', 'active': 'default' },
//         { 'label': 'LowestPriceA', 'val': 'LowestPrice', 'sortType': 'ASC', 'active': 'default' },
//         { 'label': 'LowestPriceD', 'val': 'LowestPrice', 'sortType': 'DESC', 'active': 'default' },
//         { 'label': 'Most', 'val': 'PriceCount', 'sortType': 'DESC', 'active': 'default' },
//         { 'label': '最晚结束', 'val': 'EffectiveTimeStamp', 'sortType': 'DESC', 'active': 'default' },
//         { 'label': '最早发布', 'val': 'LastOnTimeStamp', 'sortType': 'ASC', 'active': 'default' },

let cardhobby = {
  PropertyList: [
    /*
     * 分类浏览选项列表
     * 篮球、 橄榄球、 棒球 、冰球、足球、 UFC 、WWE、F1 、Other Sports（其他运动）、宝可梦、Gaming（其他游戏）、娱乐（entertainment）*/
    { 'Id': '175af7b5-d6bc-4d44-b913-9f8da05e3288', "url": "../../static/images/basketball.jpg", 'ChName': '篮球', 'EnName': 'Basketball', 'KeyType': 'Sports', 'key': 1, 'index': '0-0-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', 'TId': '10106fda-c5d8-4121-ab21-0428534eaf42' },
    { 'Id': '5efa4eb7-c519-403c-88e0-51a4b76cbd1e', "url": "../../static/images/football.jpg", 'ChName': '足球', 'EnName': 'Soccer', 'KeyType': 'Sports', 'key': 2, 'index': '0-0-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', 'TId': '10106fda-c5d8-4121-ab21-0428534eaf42' },
    { 'Id': 'e6fd3abb-ac0f-4537-8712-6417e9c23a25', "url": "../../static/images/rugby.jpg", 'ChName': '橄榄球', 'EnName': 'Football', 'KeyType': 'Sports', 'key': 3, 'index': '0-0-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', 'TId': '10106fda-c5d8-4121-ab21-0428534eaf42' },
    { 'Id': 'a92bc03d-8400-4362-9142-0fef2b2b02a2', "url": "../../static/images/tennis.jpg", 'ChName': '棒球', 'EnName': 'Baseball', 'KeyType': 'Sports', 'key': 4, 'index': '0-0-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', 'TId': '10106fda-c5d8-4121-ab21-0428534eaf42' },
    { 'Id': '57e242de-4e1f-47b0-8056-3ef1c0931488', "url": "../../static/images/ice_hockey.jpg", 'ChName': '冰球', 'EnName': 'Hockey', 'KeyType': 'Sports', 'key': 5, 'index': '0-0-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', 'TId': '10106fda-c5d8-4121-ab21-0428534eaf42' },

    { 'Id': '9be61af5-9e00-4cb0-af99-d96b1b37bc4d', "url": "../../static/images/RatingCard.jpg", 'ChName': 'Graded Card', 'EnName': 'Graded card', 'OtherName': '', 'KeyType': 'Sports', 'key': 6, 'index': '0-0-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', 'TId': '10106fda-c5d8-4121-ab21-0428534eaf42' },

    { 'Id': '9be61af5-9e00-4cb0-af99-d96b1b37bc4d', "url": "../../static/images/UFC.jpg", 'ChName': 'UFC/MMA', 'EnName': 'UFC', 'OtherName': '综合格斗', 'KeyType': 'Sports', 'key': 7, 'index': '0-0-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', 'TId': '10106fda-c5d8-4121-ab21-0428534eaf42' }, //终极格斗
    { 'Id': '86083b79-7a63-4bd7-abff-b8c75ca85a3c', "url": "../../static/images/WWE.jpg", 'ChName': 'WWE', 'EnName': 'WWE', 'OtherName': '美式摔跤', 'KeyType': 'Sports', 'key': 8, 'index': '0-0-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', 'TId': '10106fda-c5d8-4121-ab21-0428534eaf42' },
    { 'Id': '7529cfb1-5a44-4e55-9de1-453b78dbaf3e', "url": "../../static/images/F1.jpg", 'ChName': 'F1', 'EnName': 'F1', 'OtherName': '一级方程式锦标赛', 'KeyType': 'Sports', 'key': 9, 'index': '0-0-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', 'TId': '10106fda-c5d8-4121-ab21-0428534eaf42' }, //一级方程式锦标赛
    { 'Id': '1aa8fa18-4c5b-47cc-8e03-acf2073dd5e4', "url": "../../static/images/Pokemon.jpg", 'ChName': '宝可梦', 'EnName': 'Pokemon', 'KeyType': 'GameComic', 'key': 10, 'index': '0-2-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '55b61752-b4b2-4437-8eba-a9f21cc14b6f', 'TId': '2794188f-92c7-4c8b-bf7b-019e8bb07e8b' },
    { 'Id': '', "url": "../../static/images/Gaming.jpg", 'ChName': '游戏王', 'EnName': 'Yu-Gi-Oh! TCG', 'KeyType': 'GameComic', 'key': 11, 'index': '0-2-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '55b61752-b4b2-4437-8eba-a9f21cc14b6f', 'TId': '2794188f-92c7-4c8b-bf7b-019e8bb07e8b' },
    { 'Id': '', "url": "../../static/images/OtherSport.jpg", 'ChName': '手绘', 'EnName': 'Sketch', 'KeyType': 'Card', 'key': 12, 'index': '0-2-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '7c8a9434-60b1-4f21-b2ee-6bfd654d5d47', 'TId': '5f75ac02-f9b6-4015-b931-76a584fc1827' },

    { 'Id': '', "url": "../../static/images/CardFun.jpg", 'ChName': '集卡社', 'EnName': 'CardFun', 'KeyType': 'Card', 'key': 13, 'index': '0-2-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': 'd634f061-a23c-42ba-88f6-91052f315579', 'TId': 'f8281a05-a528-49ad-bd20-7259060705de' },

    { 'Id': '', "url": "../../static/images/Entertainment.jpg", 'ChName': '娱乐', 'EnName': 'Non-Sports', 'KeyType': 'Card', 'key': 12, 'index': '0-2-0', 'FId': 'dee8e93d-bf0d-46d7-a817-45db58756940', 'SId': '5bbcb634-3298-4655-9eda-67ab2d39afae', 'TId': '385b99fb-8d90-4cef-8e3e-b70d1a1c6235' }
  ],
  searchSort: [
    { 'label': 'endding', 'val': 'EffectiveTimeStamp', 'sortType': 'ASC', 'active': 'primary' },
    { 'label': 'LowestPriceA', 'val': 'LowestPrice', 'sortType': 'ASC', 'active': 'default' },
    { 'label': 'LowestPriceD', 'val': 'LowestPrice', 'sortType': 'DESC', 'active': 'default' },
    { 'label': 'Newly', 'val': 'LastOnTimeStamp', 'sortType': 'DESC', 'active': 'default' },
    { 'label': 'Most', 'val': 'PriceCount', 'sortType': 'DESC', 'active': 'default' },
  ],
  searchCategory: [
    {
      "ImgSelectedUrl": "https://images.cardhobby.com/95a3d37f978543a581efd40279b61c87.png",
      "SecondList": null,
      "Id": "4663625110899134021",
      "Title": "DAKA",
      "Sort": 0,
      "AreaCode": "US",
      "AreaName": "美国",
      "ImgUrl": "https://images.cardhobby.com/d1c0ba7f-5077-4f7c-b5c3-47747e76f5f1.png"
    },
    {
      "ImgSelectedUrl": "https://images.cardhobby.com/9f9750de184b48718c813977a5ee2c36.png",
      "SecondList": null,
      "Id": "4688832649330320642",
      "Title": "PANINI",
      "Sort": 1,
      "AreaCode": "US",
      "AreaName": "美国",
      "ImgUrl": "https://images.cardhobby.com/35775f5c-4227-429b-8836-7c38a9c97388.png"
    },
    {
      "ImgSelectedUrl": "https://images.cardhobby.com/dcfa8f366c0b4d7998a198a75858a1ec.png",
      "SecondList": null,
      "Id": "5242432215196152031",
      "Title": "HOBBY",
      "Sort": 2,
      "AreaCode": "US",
      "AreaName": "美国",
      "ImgUrl": "https://images.cardhobby.com/28c908e5-1873-4407-9a95-f8110d682e62.png"
    },
    {
      "ImgSelectedUrl": "https://images.cardhobby.com/a6205b3b1a4542968928e16ab2957925.png",
      "SecondList": null,
      "Id": "4868127715120009156",
      "Title": "TOPPS",
      "Sort": 3,
      "AreaCode": "US",
      "AreaName": "美国",
      "ImgUrl": "https://images.cardhobby.com/6bcb6858-9269-43e9-9018-31022863194c.png"
    },
    {
      "ImgSelectedUrl": "https://images.cardhobby.com/13f98d6f9d704b468f4c93870654f415.png",
      "SecondList": null,
      "Id": "4776143793317686716",
      "Title": "POKEMON",
      "Sort": 4,
      "AreaCode": "US",
      "AreaName": "美国",
      "ImgUrl": "https://images.cardhobby.com/12751b81-e9cc-4b58-b4ba-d2f47fffcd9e.png"
    },
    {
      "ImgSelectedUrl": "https://images.cardhobby.com/fd040642801c433c82b6970b42240da8.png",
      "SecondList": null,
      "Id": "4722157291975921323",
      "Title": "MAGIC",
      "Sort": 5,
      "AreaCode": "US",
      "AreaName": "美国",
      "ImgUrl": "https://images.cardhobby.com/901ca6ab-e35e-4667-94a8-d330017e125c.png"
    }
  ],
  listings: [
    { value: '0', label: i18n.t('enum.allListings') },
    { value: '2', label: i18n.t('base.auction') },
    { value: '1', label: i18n.t('base.buyNow') },
    { value: '3', label: i18n.t('enum.acceptOffers') }
  ],
  status: [
    { value: '1', label: i18n.t('enum.selling') },
    { value: '2', label: i18n.t('enum.sold') }
  ],
  graded: [
    { value: '0', label: i18n.t('enum.graded') },
    { value: '1', label: i18n.t('base.yes') },
    { value: '2', label: i18n.t('base.no') }
  ],
  bids_status: [
    { value: '1', label: i18n.t('base.all') },
    { value: '2', label: i18n.t('enum.winning') },
    { value: '3', label: i18n.t('enum.notWin') }
  ],
  offer_status: [
    { value: 'null', label: i18n.t('base.all') },
    { value: '0', label: i18n.t('enum.sent') },
    { value: '2', label: i18n.t('enum.received') },
    { value: '3', label: i18n.t('enum.declined') },
    { value: '4', label: i18n.t('enum.expired') },
  ],
  bids_sort: [
    { value: '1', label: i18n.t('enum.endingSoonest') },
    { value: '2', label: i18n.t('enum.newlyListed') },
  ],
  offer_sort: [
    { value: '1', label: i18n.t('enum.endingSoonest') },
    { value: '2', label: i18n.t('enum.newlyListed') },
    // { value: '3', label: 'Price Lowest' },
    // { value: '4', label: 'Price Highest' },
    { value: '3', label: i18n.t('enum.lowToHigh') },
    { value: '4', label: i18n.t('enum.highToLow') },
  ],
  seller_sort: [
    { value: '1', label: i18n.t('enum.dataAdded') },
    { value: '3', label: i18n.t('enum.byName') },
  ],
  arrived: [
    { value: 0, label: i18n.t('enum.allStatus') },
    { value: 1, label: i18n.t('base.disputing') },
    { value: 2, label: i18n.t('base.disputed') },
    // { value: 3, label: 'Revoke' },
  ],
  header_type: [
    { value: '1', label: i18n.t('base.items') },
    { value: '2', label: i18n.t('base.seller') },
  ],
  watch_status: [
    // { value: '2', label: 'All' },
    { value: '1', label: i18n.t('enum.active') },
    { value: '-1', label: i18n.t('enum.ended') },
  ],
  watch_Sort: [
    //1=最早结束，2=价格（低-高），3=价格（高-低），4=最新关注
    { value: '1', label: i18n.t('enum.endingSoonest') },
    { value: '2', label: i18n.t('enum.priceLowest') },
    { value: '3', label: i18n.t('enum.priceHighest') },
    { value: '4', label: i18n.t('enum.recentlyAdded') },
  ],
  search_Sort: [ 
    { value: 1, label: i18n.t('base.name') },
    { value: 2, label: i18n.t('enum.dataAdded')},
    { value: 3, label: i18n.t('enum.lastViewed')},
  ],
  feedback_status: [
    { value: '', label: i18n.t('base.all') },
    { value: '1', label: i18n.t('base.buyer') },
    { value: '2', label: i18n.t('base.seller') },
  ],
  OrderStatus: {
    //待支付1，待发货2，待收货3，待评价4，交易完成5，关闭6
    "1": i18n.t('base.toBePaid'),
    "2": i18n.t('base.toBeShipped'),
    "3": i18n.t('base.shipped'),
    "4": i18n.t('base.toLeave'),
    "5": i18n.t('base.finished'),
    "6": i18n.t('base.closed'),
  },
  // 各類彈框的名字與狀態
  dislogType: {
    'coupon': false,
    'express': false,
    'comment': false,
    'address': false,
    'safeguard': false,
    'confirm': false,
    'offerhistory': false,
    'placebid': false,
    'makeoffer': false,
    'domestic': false,
    'feedback': false,
    'weight': false,
    'contact': false,
    'changePhone': false,
    'warehouse': false,
    'taxDetails':false,
    'taxorderlist':false,
    'taxorder':false,
    'ordercheck':false,
    'commodityaddress':false,
    'idverification':false,
    'verifynow':false,
    'taxDeclaration':false
  },
  activtyType: {
    'activty': false,
  },
  uoloadType: {
    'upload': false,
  },
  cosConfig: {
    ImagesUrl: "https://images.cardhobby.com/",
    Bucket: "cardhobby-1255531135" /* 必须 */ ,
    Region: "ap-shanghai" /* 存储桶所在地域，必须字段 */ ,
    Key: "exampleobject" /* 必须 */ ,
    Prefix: "", //CardHobby/ /*文件目录*/
    SecretId: "",
    SecretKey: ""
  },
  // 合規文檔的標題
  // policies: [
  //   i18n.t('title.rulesAndPolicies'),
  //   i18n.t('title.privacyNotice'),
  //   i18n.t('title.userAgreement'),
  //   i18n.t('title.chTradingRules'),
  //   i18n.t('title.auctionRules'),
  //   i18n.t('title.activityRule'),
  //   i18n.t('title.settlementAgreement'),
  //   i18n.t('title.closingDeleting'),
  //   i18n.t('title.boxesCases'),
  // ],
  // 競拍階梯價格對照表
  place: [
    { max: 19.99, min: 1.00, key: 1 },
    { max: 39.99, min: 20.00, key: 2 },
    { max: 99.99, min: 40.00, key: 5 },
    { max: 199.99, min: 100.00, key: 10 },
    { max: 499.99, min: 200.00, key: 15 },
    { max: 999.99, min: 500.00, key: 25 },
    { max: 1999.99, min: 1000.00, key: 50 },
    { max: 4999.99, min: 2000.00, key: 100 },
    { max: 9999.99, min: 5000.00, key: 200 },
    { max: '', min: 10000.00, key: 250 },
  ],
  // 多語言
  languages: [
    { label: i18n.t('languages.en'), value: "en" },
    { label: i18n.t('languages.zh_TW'), value: "zh-tw" },
    { label: i18n.t('languages.ko_KR'), value: "ko" },
    { label: i18n.t('languages.ja'), value: "ja" }
  ],
  facturerLogo: [
    { "key": "Daka", "url": "../../static/images/daka.png" },
    { "key": "Panini", "url": "../../static/images/PANINI_HOBBY.png" },
    { "key": "PaniniAsia", "url": "../../static/images/PANINI_ASIA.png" },
    { "key": "Topps", "url": "../../static/images/topps.png" },
    { "key": "Pokemon", "url": "../../static/images/POKEMON.png" },
    { "key": "Magic", "url": "../../static/images/MAGIC.png" },
  ],
  // 報錯的文案
  error: {
    "NOSell": i18n.t('alert.noLicence'),
    "NOShare": i18n.t('alert.shareExpired'),
    "NOimg": i18n.t('alert.imgType'),
  },
  //支付方式的圖標
  payChannels: {
    paypal: "../../static/images/paypal2.png",
    stripe: "../../static/images/stripe.png",
    mpay: "../../static/images/mpay.png",
    usdt: "../../static/images/usdt.png",
  },
  // 支付方式的code
  paylist: {
    paypal: 3,
    stripe: 6,
    mpay: 9,
    other:12,
    usdt:14,
  },
  // 區域枚舉
  AreaData: [
    { areaCode: 'US',browserLanguages:'en-US',areaName: i18n.t('region.UnitedStates'), areaChName: '美國', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'CN',browserLanguages:'zh-CN', areaName: i18n.t('region.China'), areaChName: '中國', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'MO',browserLanguages:'', areaName: i18n.t('region.Macao'), areaChName: '澳門', areaSymbol: 'MOP', currencySymbol: '$' },
    { areaCode: 'HK',browserLanguages:'zh-HK', areaName: i18n.t('region.HongKong'), areaChName: '香港', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'TW',browserLanguages:'zh-TW', areaName: i18n.t('region.Taiwan'), areaChName: '台灣', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'AU',browserLanguages:'', areaName: i18n.t('region.Australia'), areaChName: '澳大利亞', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'SG',browserLanguages:'', areaName: i18n.t('region.Singapore'), areaChName: '新加坡', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'GB',browserLanguages:'en-GB', areaName: i18n.t('region.Britain'), areaChName: '英國', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'FR',browserLanguages:'fr-FR', areaName: i18n.t('region.France'), areaChName: '法國', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'DE',browserLanguages:'de-DE', areaName: i18n.t('region.Germany'), areaChName: '德國', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'ID',browserLanguages:'', areaName: i18n.t('region.Indonesia'), areaChName: '印度尼西亞', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'JP',browserLanguages:'ja', areaName: i18n.t('region.Japan'), areaChName: '日本', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'KR',browserLanguages:'ko', areaName: i18n.t('region.SouthKorea'), areaChName: '韓國', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'MY',browserLanguages:'', areaName: i18n.t('region.Malaysia'), areaChName: '馬來西亞', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'PH',browserLanguages:'', areaName: i18n.t('region.Philippines'), areaChName: '菲律賓', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'BR',browserLanguages:'', areaName: i18n.t('region.Brazil'), areaChName: '巴西', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'IT',browserLanguages:'', areaName: i18n.t('region.Italia'), areaChName: '意大利', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'PE',browserLanguages:'', areaName: i18n.t('region.Peru'), areaChName: '秘魯', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'CA',browserLanguages:'', areaName: i18n.t('region.Canada'), areaChName: '加拿大', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'EC',browserLanguages:'', areaName: i18n.t('region.Ecuador'), areaChName: '厄瓜多爾', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'SA',browserLanguages:'', areaName: i18n.t('region.SaudiArabia'), areaChName: '沙特阿拉伯', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'ES',browserLanguages:'', areaName: i18n.t('region.Spain'), areaChName: '西班牙', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'TR',browserLanguages:'', areaName: i18n.t('region.Turkey'), areaChName: '土耳其', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'AR',browserLanguages:'', areaName: i18n.t('region.Argentina'), areaChName: '阿根廷', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'HU',browserLanguages:'', areaName: i18n.t('region.Hungar'), areaChName: '匈牙利', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'IN',browserLanguages:'', areaName: i18n.t('region.India'), areaChName: '印度', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'TH',browserLanguages:'', areaName: i18n.t('region.Thailand'), areaChName: '泰國', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'PT',browserLanguages:'', areaName: i18n.t('region.Portugal'), areaChName: '葡萄牙', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'EE',browserLanguages:'', areaName: i18n.t('region.Estonia'), areaChName: '愛沙尼亞', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'PL',browserLanguages:'', areaName: i18n.t('region.Polska'), areaChName: '波蘭', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'SI',browserLanguages:'', areaName: i18n.t('region.Slovenia'), areaChName: '斯洛文尼亞', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'NL',browserLanguages:'nl', areaName: i18n.t('region.Nederland'), areaChName: '荷蘭', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'EG',browserLanguages:'', areaName: i18n.t('region.Egypt'), areaChName: '埃及', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'BE',browserLanguages:'', areaName: i18n.t('region.Belgium'), areaChName: '比利時', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'IE',browserLanguages:'', areaName: i18n.t('region.Ireland'), areaChName: '愛爾蘭', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'AT',browserLanguages:'', areaName: i18n.t('region.Austria'), areaChName: '奧地利', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'DK',browserLanguages:'', areaName: i18n.t('region.Denmark'), areaChName: '丹麥', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'FL',browserLanguages:'', areaName: i18n.t('region.Finland'), areaChName: '芬蘭', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'HN',browserLanguages:'', areaName: i18n.t('region.Honduras'), areaChName: '洪都拉斯', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'CZ',browserLanguages:'', areaName: i18n.t('region.Czech'), areaChName: '捷克', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'HR',browserLanguages:'', areaName: i18n.t('region.Croatia'), areaChName: '克羅地亞', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'LU',browserLanguages:'', areaName: i18n.t('region.Luxembourg'), areaChName: '盧森堡', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'MM',browserLanguages:'', areaName: i18n.t('region.Myanmar'), areaChName: '緬甸', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'SE',browserLanguages:'', areaName: i18n.t('region.Sverige'), areaChName: '瑞士', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'SV',browserLanguages:'', areaName: i18n.t('region.Salvador'), areaChName: '薩爾瓦多', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'TR',browserLanguages:'', areaName: i18n.t('region.Türkiye'), areaChName: '土耳其', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'NZ',browserLanguages:'', areaName: i18n.t('region.NewZealand'), areaChName: '紐新蘭', areaSymbol: 'USD', currencySymbol: '$' },
    { areaCode: 'IT',browserLanguages:'', areaName: i18n.t('region.Italy'), areaChName: '意大利', areaSymbol: 'USD', currencySymbol: '$' }
  ],
  appcompanyinfo: [
    { 'content': 'Card Hobby was established in Shanghai by a team with experts who have over 20 years’experience in sports trading cards.', 'type': 'primary', 'timestamp': '2014', 'icon': 'el-icon-node' },
    { 'content': 'Acquiring KaZu platform, combined sports card market in China.', 'type': 'primary', 'timestamp': '2016', 'icon': 'el-icon-node' },
    { 'content': 'The beginning of oversea business for Card Hobby.', 'minorcontent': 'Attend NSCC in U.S. and start the open registration for oversea customers.', 'type': 'primary', 'timestamp': '2018', 'icon': 'el-icon-node' },
    { 'content': 'The beginning of oversea business for Card Hobby.', 'type': 'primary', 'timestamp': '2019', 'icon': 'el-icon-node' },
    { 'content': 'In early 2020, even if there is an outbreak of COVID-19, Card Hobby grew rapidly against the trend.', 'minorcontent': 'The stage of rapid development, start online guarantee transaction that can ensure the security.', 'type': 'primary', 'timestamp': '2020', 'icon': 'el-icon-node' },
    { 'content': 'Introduce UnionPay payment system, upgrade the security of transaction.', 'type': 'primary', 'timestamp': '2021', 'icon': 'el-icon-node' },
    { 'content': 'Achieve a strategic cooperation with PSA, keep exploring the global market.', 'minorcontent': 'Card Hobby has obtained a hundred-million funding (Round A) from Shanghai YaoJi technology Co,Ltd.', 'type': 'primary', 'timestamp': '2022', 'icon': 'el-icon-node' },
    { 'content': '', 'minorcontent': '', 'type': '', 'timestamp': '', 'icon': '' }
  ]
}
export default {
  cardhobby
}



// WEBPACK FOOTER //
// ./src/api/enum.js